import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { studentRetrieveEligibleTrainingItems } from "./retrieve-eligible-training-items";
import type { EligibleTrainingItemsVM } from "@academy-context/shared/domain/types/eligible-training-items";
import { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";

const initialState: RetrievalState<EligibleTrainingItemsVM> = {
  fetching: "idle",
  data: {
    [TRAINING_ITEM_TYPE.ONE_ON_ONE_LESSONS]: [],
    [TRAINING_ITEM_TYPE.PROVIDER_BATCH]: [],
    [TRAINING_ITEM_TYPE.TEACHER_BATCH]: [],
    [TRAINING_ITEM_TYPE.EXTERNAL_PROVIDER_BATCH]: [],
  },
};

export const studentRetrieveEligibleTrainingItemsReducer = createReducer<RetrievalState<EligibleTrainingItemsVM>>(initialState, builder => {
  builder.addCase(studentRetrieveEligibleTrainingItems.fulfilled, (state, { payload }) => {
    return { ...state, data: payload, fetching: "success" };
  });
  builder.addCase(studentRetrieveEligibleTrainingItems.pending, state => {
    return { ...state, fetching: "pending" };
  });
  builder.addCase(studentRetrieveEligibleTrainingItems.rejected, state => {
    return { ...state, fetching: "failed" };
  });
});
